import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/wishlist";

export default class Wishlist extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Wishlist")} | ${this.ucfirst("window-title")}`
    );
  }
}
